import React, { useState, useContext, useEffect } from 'react';
import axios from '../../config/axios';

import UsersContext from '../../contexts/usersContext';
import AuthContext from '../../contexts/AuthContext';

import Event from './Event/Event';
import Filter from '../../components/UI/Filter/Filter';
import Info from '../../components/UI/Info/Info';
import Button from '../../components/UI/Button/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Search from '../../components/UI/Search/Search';
import { ReactComponent as DownloadIcon } from '../../svg/get_app.svg';
import tutorial from '../../assets/cmk2020-teams-instruction.pdf';
import program from '../../assets/cmk2020-program-summary.pdf';

import classes from './Schedule.module.scss';
import authData from '../../config/authData';

const Schedule = props => {
    const Users = useContext(UsersContext)[0].participants;
    const auth = useContext(AuthContext)[0];
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showTodaysLectures, setShowTodaysLectures] = useState(false);
    const [localAuth, setLocalAuth] = useState(false);
    const [filters, setFilters] = useState({
        room: ''
    })
    const [loading, setLoading] = useState(true);
    const [days, setDays] = useState(null);
    const [rooms, setRooms] = useState(null);
    const [restorePassword, setRestorePassword] = useState(false);
    const [localAuthError, setLocalAuthError] = useState(null);
    const [searchByName, setSearchByName] = useState('');

    useEffect(() => {
        const getDays = axios.get(`/days.json?auth=${auth.token}`);
        const getRooms = axios.get(`/rooms.json?auth=${auth.token}`);

        Promise.all([getDays, getRooms])
            .then(response => {
                console.log(response[0], response[1])
                setDays(response[0].data);
                setRooms(response[1].data);
                setLoading(false);
            })
            .catch(err => {
                console.log('SCHEDULE_DAYS_LOADING', err.message);
            })
    }, [])

    const onFilterChangedHandler = (id, value) => {
        const updatedFilters = {
            ...filters,
            [id]: value
        }
        setFilters(updatedFilters);
    }

    const onLocalAuthHandler = () => {
        const url = 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyDLmUJLhu3Z8sosomrmLJjFVnrLV81-IME';
        const userAuthData = {
            email: email,
            password: password,
            returnSecureToken: true
        }
        setLocalAuthError(null);

        axios.post(url, userAuthData)
            .then(result => {
                // console.log('[LOCAL_AUTH_DATA]', result.data)
                setLocalAuth(true);
            })
            .catch(error => {
                setLocalAuthError('Please, provide correct login data')
            })

    }

    const onKeyAuthStart = event => {
        event.preventDefault();
        console.log('[ENTER]')
        if (event.key === 'Enter') {
            console.log('[ENTER]')
        }
    }

    const onRestorePasswordHandler = () => {
        setRestorePassword(true);
    }

    const onRestorePasswordActionHandler = () => {
        const url = 'https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key=AIzaSyDLmUJLhu3Z8sosomrmLJjFVnrLV81-IME';
        const requestData = {
            requestType: 'PASSWORD_RESET',
            email: email
        }

        axios.post(url, requestData)
            .then(_ => {
                setRestorePassword(false);
            })
    }

    let displayedData = null;
    if (days && rooms) {
        displayedData = Object.keys(Users)
            .map(key => {
                return {
                    key: key,
                    data: Users[key]
                }
            })
            .filter(el => (el.data.day))
            .filter(el => {
                const participantName = `${el.data.firstName} ${el.data.lastName}`;
                return participantName.toLowerCase().includes(searchByName.toLowerCase());
            })
            .sort((el1, el2) => {
                if (`${days[el1.data.day].day} ${el1.data.hour}` >= `${days[el2.data.day].day} ${el2.data.hour}`) {
                    return 1;
                }
                else {
                    return -1;
                }
            })
            .filter(el => {
                if (showTodaysLectures) {
                    // console.log('[Date]', el.data.day ? days[el.data.day].day : 'None');
                    const now = new Date();
                    const y = now.getFullYear();
                    const m = `${now.getMonth()}`;
                    const d = `${now.getDate()}`;
                    const today = `${y}-${m.length === 1 ? `0${now.getMonth() + 1}` : `${now.getMonth() + 1}`}-${d.length === 1 ? `0${now.getDate()}` : `${now.getDate()}`}`;
                    console.log('[Today]', today);
                    return (today === days[el.data.day].day)
                }
                return true;
            })
            .filter(el => {
                let result = true;
                for (let fil in filters) {
                    if (filters[fil] !== '') {
                        if (el.data[fil]) {
                            result = result && el.data[fil] === filters[fil];
                        } else {
                            console.log('[]', result)
                            result = false;
                        }
                    }
                }
                return result;
            })
            .map(el => <Event
                key={el.key}
                name={`${el.data.firstName} ${el.data.lastName}`}
                affiliation={el.data.affiliation}
                title={el.data.title}
                day={el.data.day ? days[el.data.day].day : null}
                hour={el.data.hour ? el.data.hour : null}
                abstract={el.data.abstract}
                room={el.data.room ?
                    el.data.room.length > 0
                        ? rooms[el.data.room].description
                        : null
                    : null}
                link={el.data.room ?
                    el.data.room.length > 0
                        ? rooms[el.data.room].link
                        : null
                    : null}
                showModal={props.showModal}
                setModalContent={props.setModalContent}
                auth={localAuth}
            />)
    }


    let displayedFilters = [];
    if (filters) {
        displayedFilters = Object.keys(filters)
            .map(key => ({
                id: key,
                value: filters[key]
            }))
            .map(el => <Filter
                key={el.id}
                id={el.id}
                filter={el.id}
                changed={onFilterChangedHandler} />
            );
    }

    const authSection = <div className={classes.AuthSection}>
        <Info withIcon={false}>To read abstract, click the talk title. Please, sign in to reveal talk details. Follow <span
            className={classes.RestorePassword}
            onClick={onRestorePasswordHandler}>this link to restore password.</span></Info>
        {setLocalAuthError && <div className={classes.ErrorMessage}>{localAuthError}</div>}
        <div className={classes.Form}>
            <input className={classes.Input} onChange={event => setEmail(event.target.value)} type="email" placeholder="E-mail" />
            <input className={classes.Input} onChange={event => setPassword(event.target.value)} type="password" placeholder="Password" />
            <button className={classes.SignIn} onClick={onLocalAuthHandler} onKeyPress={onKeyAuthStart}>Sign in</button>
        </div>
    </div>

    const restorePasswordSection = <div className={classes.AuthSection}>
        <Info withIcon={false}>Please, fill the e-mail with data provided during registration to restore your password. We will email you a link to the exteternal resources to change your password. <span className={classes.RestorePassword}
            onClick={() => setRestorePassword(false)}>Click here to return.</span></Info>
        <div className={classes.Form}>
            <input className={classes.Input} onChange={event => setEmail(event.target.value)} type="email" placeholder="E-mail" />
            <button className={classes.SignIn} onClick={onRestorePasswordActionHandler}>Restore password</button>
        </div>
    </div>

    return <div className={classes.Right}>
        <h1>Schedule</h1>
        <div className={classes.Downloads}>
            <div className={classes.Download}>
                <DownloadIcon /><a
                    href={program}
                    target='_blank'
                    rel='noreferrer noopener'>Conference summary program</a>
            </div>
            <div className={classes.Download}>
                <DownloadIcon /><a
                    href={tutorial}
                    target='_blank'
                    rel='noreferrer noopener'>Microsoft Teams instruction</a>
            </div>
        </div>
        {(!localAuth && !restorePassword) ? authSection : null}
        {(!localAuth && restorePassword) ? restorePasswordSection : null}
        {localAuth && <Info>Please, follow the conference room description link to switch directly to MS Teams website. To read abstract, click the talk title.</Info>}
        <div className={classes.Filters}>
            {displayedFilters}
        </div>
        <Search
            filter={searchByName}
            setFilter={setSearchByName}
            placeholder="Search by participant's name" />
        <div className={classes.ShowTodaysLectures}>
            <Button type="wide" clicked={() => setShowTodaysLectures(!showTodaysLectures)}>
                {!showTodaysLectures ? 'Show todays lectures' : 'Show all lectures'}</Button>
        </div>
        <div>
            {!loading ? displayedData : <Spinner />}
        </div>

    </div>
}

export default Schedule;